module.exports = __webpack_public_path__ + "CI.png?f0a4a32cd5ac0e02db77889296411703";